'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _ref = _jsx('span', {
    className: 'm-sign-modal--action-bar--close-link--arrow'
});

var _ref2 = _jsx(_reactIntl.FormattedMessage, {
    id: 'signModal.actions.back.linkText'
});

var ActionBar = _react2['default'].createClass({
    displayName: 'ActionBar',


    propTypes: {
        'onInsert': _react2['default'].PropTypes.func.isRequired,
        'onClose': _react2['default'].PropTypes.func.isRequired,
        'locales': _react2['default'].PropTypes.array.isRequired,
        'message': _react2['default'].PropTypes.string,
        'messages': _react2['default'].PropTypes.object.isRequired,
        'isMobile': _react2['default'].PropTypes.bool.isRequired,
        'canInsertEverywhere': _react2['default'].PropTypes.bool,
        'disableButtons': _react2['default'].PropTypes.bool,
        'continueInsteadOfInsert': _react2['default'].PropTypes.bool,
        'onContinue': _react2['default'].PropTypes.func,
        'buttonText': _react2['default'].PropTypes.string // Text to be displayed on the CTA (only when canInsertEverywhere=false)
    },

    //  ----  LIFECYCLE  ----------------------------------

    getDefaultProps: function getDefaultProps() {
        return {
            'canInsertEverywhere': true,
            'disableButtons': false,
            'continueInsteadOfInsert': false,
            'onContinue': null
        };
    },

    //  ----  BEHAVIOR  -----------------------------------

    insertSignature: function insertSignature(insertEverywhere) {
        this.props.onInsert(insertEverywhere);
    },

    close: function close() {
        this.props.onClose();
    },

    //  ----  RENDERING  ----------------------------------

    render: function render() {

        var buttons = [];
        var buttonProps = [{
            'buttonId': 'insertButton',
            'buttonColor': 'white',
            'buttonHoverColor': this.props.isMobile ? 'white' : 'cerulean',
            'buttonTextColor': 'cerulean',
            'buttonHoverTextColor': this.props.isMobile ? 'cerulean' : 'white',
            'className': this.props.disableButtons ? void 0 : 'whitelabel-secondary-button',
            'buttonBorderColor': this.props.disableButtons ? 'cinder-block' : 'cerulean',
            'disabled': this.props.disableButtons,
            'intl': this.props.intl
        }, this.props.canInsertEverywhere ? {
            'buttonId': 'insertEverywhereButton',
            'buttonColor': 'cerulean',
            'buttonTextColor': 'white',
            'buttonHoverColor': this.props.isMobile ? 'cerulean' : null,
            'buttonHoverTextColor': 'white',
            'className': this.props.disableButtons ? void 0 : 'whitelabel-primary-button',
            'buttonBorderColor': this.props.disableButtons ? 'cinder-block' : 'cerulean',
            'disabled': this.props.disableButtons,
            'intl': this.props.intl
        } : void 0];

        var continueButtonProps = {
            'buttonId': 'continueButton',
            'buttonColor': 'cerulean',
            'buttonTextColor': 'white',
            'buttonHoverColor': this.props.isMobile ? 'cerulean' : null,
            'buttonBorderColor': this.props.disableButtons ? 'cinder-block' : 'cerulean',
            'buttonHoverTextColor': 'white',
            'className': 'whitelabel-primary-button',
            'intl': this.props.intl
        };

        if (this.props.continueInsteadOfInsert) {

            buttons.push(_react2['default'].createElement(_button2['default'], _extends({
                key: 'sign-modal-button-continue',
                buttonText: this.props.intl.formatMessage({ id: 'signModal.actions.continue.labelText' }, { 'everywhere': i }),
                disabled: this.props.disableButtons,
                onClick: this.props.onContinue
            }, continueButtonProps)));
        } else {

            // Normal insert buttons
            for (var i = 0; i < 2; i++) {
                if (buttonProps[i]) {
                    var buttonText;
                    if (i === 0 && !this.props.canInsertEverywhere && this.props.buttonText) {
                        buttonText = this.props.buttonText;
                    } else {
                        buttonText = this.props.intl.formatMessage({ id: 'signModal.actions.insert.linkText' }, { 'everywhere': i });
                    }
                    buttons.push(_react2['default'].createElement(_button2['default'], _extends({
                        key: 'sign-modal-button-' + i,
                        buttonText: buttonText,
                        onClick: this.props.disableButtons ? null : this.insertSignature.bind(null, i === 1)
                    }, buttonProps[i])));
                }
            }
        }

        var message = this.props.message;
        if (message == void 0) {
            // null = don't show a message
            message = _jsx(_reactIntl.FormattedMessage, {
                id: 'signModal.actions.legal.labelText',
                values: { type: this.props.type }
            });
        }

        var notif = message && this.props.isMobile ? _jsx('div', {
            className: 'm-sign-modal--action-bar--notification'
        }, void 0, message) : null;
        return _jsx('div', {
            className: 'm-sign-modal--action-bar'
        }, void 0, notif, _jsx('div', {
            className: 'm-sign-modal--action-bar--inner'
        }, void 0, _jsx('div', {
            className: 'm-sign-modal--action-bar--close-link'
        }, void 0, _jsx('a', {
            href: 'javascript:;',
            onClick: this.close
        }, void 0, _ref, _jsx('span', {
            className: 'm-sign-modal--action-bar--close-link--text'
        }, void 0, _ref2))), _jsx('div', {
            className: 'm-sign-modal--action-bar--message'
        }, void 0, message || ''), _jsx('div', {
            className: 'm-sign-modal--action-bar--buttons'
        }, void 0, buttons)));
    }
});

module.exports = ActionBar;


/*****************
 ** WEBPACK FOOTER
 ** ./src/signer/components/common/signature-modal/action-bar.jsx
 ** module id = 678
 ** module chunks = 0
 **/